<template>
	<div class="register form overflow">
		<button ref="btnSendCodeVerification" @click="sendCodeVerificationLocal()" v-show="false"></button>
		<h4 class="mt-2">Registro</h4>
		<div class="row" v-if="!verifiedCode">
			<div class="col-12">
				<label>Hemos enviado un codigo a {{email}}, utilicelo aquí para continuar</label>
				<input type="text" class="text-center" id="code" v-model="objectClientExt.code" placeholder="Código" maxlength="6">
			</div>
		</div>
		<div class="row" v-else>
			<div class="col-12">
				<div>
					<label for="email" class="form-label">Correo electronico</label>
					<small class="float-end">
						<i class=""></i>
						<i class="spinner-border text-warning"  style="width: 16px; height: 16px" title="Estamos está verificando su correo" v-if="objectClientExt.token == ''"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="email" class="form-control form-control-sm" id="email" placeholder="micorreo@ejemplo.com" v-model="objectClient.email" readonly>
			</div>

			<div class="col-12">
				<label for="address" class="form-label">Iglesia</label>
				<churchs-input-component @actionSelectItem="selectItemChurch" ref="churchsInputComponent"></churchs-input-component>
			</div>

			<div class="col-12">
				<div>
					<label for="firstName" class="form-label">Nombre</label>
					<small class="float-end">
						<i class="fa-solid fa-circle-info text-warning" title="Debe minimo 3 caracteres - Ej: Ana" v-if="!checkDataLength(objectClient.name, 3)"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="text" class="form-control form-control-sm" id="firstName" placeholder="" v-model="objectClient.name" placeholder="ej: Juan" required>
			</div>

			<div class="col-12">
				<div>
					<label for="lastName" class="form-label">Apellidos</label>
					<small class="float-end">
						<i class="fa-solid fa-circle-info text-warning" title="Debe minimo 3 caracteres - Ej: Cox" v-if="!checkDataLength(objectClient.surname, 3)"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="text" class="form-control form-control-sm" id="lastName" placeholder="" v-model="objectClient.surname" placeholder="ej: Perez" required>
			</div>

			<div class="col-12">
				<div>
					<label for="phone" class="form-label">Celular</label>
					<small class="float-end">
						<i class="fa-solid fa-circle-info text-warning" title="Debe contener 9 digitos - Ej: 912345679" v-if="!checkDataLength(objectClient.phone, 9, '==')"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="text" class="form-control" id="phone" placeholder="ej: 912345678" v-model="objectClient.phone">
			</div>

			<div class="col-12">
				<div>
					<label for="password" class="form-label">Contraseña</label>
					<small class="float-end">
						<i class="fa-solid fa-circle-info text-warning" title="Debe contener minimo 8 caracteres - Ej: qdmumler" v-if="!checkDataLength(objectClientExt.password, 8)"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="password" class="form-control" id="password" placeholder="ej: ft5rtw2Re2" v-model="objectClientExt.password">
			</div>

			<div class="col-12">
				<div>
					<label for="passwordRepeat" class="form-label">Repita su contraseña</label>
					<small class="float-end">
						<i class="fa-solid fa-circle-info text-warning" title="Debe ser igual a la contraseña anterior"
							v-if="objectClientExt.password != objectClientExt.passwordRepeat || !checkDataLength(objectClientExt.passwordRepeat, 8)"></i>
						<i class="fa-solid fa-check text-success" v-else></i>
					</small>
				</div>
				<input type="password" class="form-control" id="passwordRepeat" placeholder="ej: ft5rtw2Re2" v-model="objectClientExt.passwordRepeat">
			</div>
		</div>
		<hr class="my-4">

		<button class="mb-4" type="submit" :disabled="disabledBtnSaveClient" @click="next">
			<span v-if="!savingClient">
				<span v-if="!verifiedCode">Verificar</span>
				<span v-else>Guardar</span>
			</span>
			<span v-else>Guardando...</span>
		</button>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'
	import client from '@/mixins/client.js'
	import church from '@/mixins/church.js'

  import ChurchsInputComponent from '@/components/ChurchsInputComponent.vue'

  export default {
		name: 'Register',
		mixins: [mixin, client, church, axiosAWN],
		props: ['email'],
		data() {
			return {
				data: {
					email: this.email,
					link: 'https://suscripcion.aceschile.cl'
				},
				codeInfo: {
					type: '',
					tokenClient: this.token,
					code: ''
				},
				checkingVerifiedCode: false,
				verifiedCode: false,
				objectClientExt: {
					code: '',
					password: '',
					passwordRepeat: '',
					churchId: 0,
					token: ''
				},
				sendingVerifiedCodePreRegister: false,
				savingClient: false
			}
		},
		components: {
			'churchs-input-component': ChurchsInputComponent,
		},
		computed: {
			disabledBtnSaveClient() {
				if(this.verifiedCode) {
					if(!this.checkDataLength(this.objectClient.name, 3)) {
						return true
					}
					if(!this.checkDataLength(this.objectClient.surname, 3)) {
						return true
					}
					if(!this.checkDataLength(this.objectClient.phone, 9, '==')) {
						return true
					}
					if(!this.checkDataLength(this.objectClientExt.password, 8)) {
						return true
					}
					if(!this.checkDataLength(this.objectClientExt.passwordRepeat, 8)) {
						return true
					}
					if(this.objectClientExt.churchId < 1) {
						return true
					}
					if(this.savingClient == true) {
						return this.savingClient
					}
					return !this.validateEmail(this.objectClient.email)
				} else {
					if(!this.checkDataLength(this.objectClientExt.code, 6, '==')) {
						return true
					}
					return false
				}
			}
		},
		methods: {
			initComponentLocal() {
				this.clearData()
				this.objectClient.email = this.email
			},
			sendCodeVerificationLocal() {
				this.objectClient.email = this.email
				this.data.email = this.email
				this.sendCodeVerificationPreRegister()
			},
			clearData() {
				this.clearObjectClient()
				this.clearObjectClientExt()
			},
			clearObjectClientExt() {
				this.objectClientExt.code = ''
				this.objectClientExt.password = ''
				this.objectClientExt.passwordRepeat = ''
				this.objectClientExt.churchId = ''
				this.objectClientExt.token = ''
			},
			checkCodeVerification() {
				if(this.objectClientExt.code.trim().length == 6) {
					this.checkingVerifiedCode = true
					let url = this.getApiBackend + 'client/checkCodeVerification'
					this.codeInfo.code = this.objectClientExt.code.trim()
					this.axiosAWNasync('Espere mientras validamos su cuenta', 'POST', url, 'checkCodeVerificationResult', this.codeInfo)
				}
			},
			checkCodeVerificationResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Cuenta chequeada')
					this.verifiedCode = 1
					setTimeout(() => { this.$refs.churchsInputComponent.$refs.getChurchs.click() }, 500)
				} else {
					this.$awn.alert(response.data.message.msg)
				}
				this.checkingVerifiedCode = false
			},
			checkCodeVerificationResultError(error) {
				console.log(error)
				this.$awn.alert('Algo no funcionó como se esperaba')
				this.checkingVerifiedCode = false
			},
			next() {
				if(this.verifiedCode) {
					this.saveClientLocal()
				} else {
					this.checkCodeVerification()
				}
			},
			saveClientLocal() {
				let url = this.getApiBackend + 'client/register'
				let data = {
						client: this.objectClient,
						ext: this.objectClientExt
					}
				this.savingClient = true
				this.axiosAWNasync('Estamos guardando su información', 'POST', url, 'saveClientResult', data)
			},
			saveClientResult(response) {
				if(response.data.success == true) {
					let options = { labels : { confirm: 'Registro Exitoso!!!'}, icons: { confirm: 'fa-solid fa-check text-success'} }
					let onOk = () => { this.$emit('actionSaveClient', this.email) };
					this.$awn.confirm('<div class="text-center">Ya está listo para ingresar al sistema.<br>Ahora será redirigido para entrar</div>', onOk, false, options)
				} else {
					this.savingClient = false
					this.$awn.alert(response.data.message + ': ' + response.data.data)
				}
			},
			saveClientResultError() {
				this.savingClient = false
			},
			selectItemChurch(item) {
				if(item.id > 0) {
					this.objectClientExt.churchId = item.id
				} else {
					this.$awn.warning('Tiene que elegir una iglesia de la lista')
				}
			},
			sendCodeVerificationPreRegister(){
				this.sendingVerifiedCodePreRegister = true
				let url = this.getApiBackend + 'client/sendCodeVerificationPreRegister'
				this.axiosAWNasyncBlock('Enviando codigo al correo ' + this.data.email, 'POST', url, 'sendCodeVerificationPreRegisterResult', this.data)
			},
			sendCodeVerificationPreRegisterResult(response) {
				if(response.data.success == true) {
					this.sendingVerifiedCodePreRegister = true
					this.objectClientExt.token = response.data.data.token
					this.codeInfo.type = response.data.data.type
					this.codeInfo.tokenClient = response.data.data.token
					this.$awn.success('Se ha enviado un codigo a su correo para completar este formulario')
				} else {
					this.$awn.alert(response.data.message + ': ' + response.data.data)
				}
			},
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<style scoped lang="scss">
/* width */
::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  opacity: 0.5;
  background: #00b7bd;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  opacity: 1;
}

input {
	background-color: #eee;
	border: none;
	padding: 12px 15px;
	margin: 8px 0;
	width: 100%;
}

button {
	border-radius: 20px;
	border: 1px solid #FF4B2B;
	background-color: #FF4B2B;
	color: #FFFFFF;
	font-size: 12px;
	font-weight: bold;
	padding: 12px 45px;
	letter-spacing: 1px;
	text-transform: uppercase;
	transition: transform 80ms ease-in;
}

button:active {
	transform: scale(0.95);
}

button:disabled, button[disabled] {
	opacity: 0.5;
}

button:focus {
	outline: none;
}

.height-100 {
	height: 100%;
}

.overflow {
	overflow-y: auto;
}
</style>

